import { gql } from 'graphql-tag';
import { useQuery } from '@apollo/client';

export const TASK_ROLE_ASSIGNMENTS_QUERY = gql`
  query getTaskRoleAssignmentsForTask(
    $taskId: String!
    $page: Int!
    $pageSize: Int!
  ) {
    task(taskId: $taskId) {
      id
      taskRoleAssignments(page: $page, pageSize: $pageSize) {
        roleAssignmentMode
        roleAssignments {
          projectRole {
            id
            displayText
          }
          isDefault
        }
      }
    }
  }
`;

export const PAGE_SIZE = 10;

const useTaskRoleAssignments = ({
  taskUri,
  page = 1,
  pageSize = PAGE_SIZE
}) => {
  const { data, loading } = useQuery(TASK_ROLE_ASSIGNMENTS_QUERY, {
    variables: { taskId: taskUri, page, pageSize },
    fetchPolicy: 'network-only',
    skip: !taskUri
  });

  const taskRoleAssignments = data?.task?.taskRoleAssignments;
  const roles = taskRoleAssignments?.roleAssignments ?? [];
  const roleAssignmentMode = taskRoleAssignments?.roleAssignmentMode ?? null;

  return {
    loading,
    roles,
    roleAssignmentMode,
    hasNextPage: roles.length === pageSize
  };
};

export default useTaskRoleAssignments;
